import { AllCloudFiles } from '../components/printers/storage/AllCloudFiles'
import { StorageLocationSlug } from '../hooks/storageLocations/useStorageLocationTabs'

export function ConnectStoragePage() {
  return <AllCloudFiles root={`/${StorageLocationSlug.CONNECT}`} />
}
